import { GdRecommendationStatus } from '../typings/graphql-grid';
import { RecommendationKey, RecommendationType, SummaryRecommendation } from '../typings/recommendations';

export const OPEN_RECOMMENDATIONS_SCREEN = 'OPEN_RECOMMENDATIONS_SCREEN';
export type OPEN_RECOMMENDATIONS_SCREEN = typeof OPEN_RECOMMENDATIONS_SCREEN;

export interface OpenRecommendationsScreen {
    type: OPEN_RECOMMENDATIONS_SCREEN;
}

export function openRecommendationsScreen(): OpenRecommendationsScreen {
    return {
        type: OPEN_RECOMMENDATIONS_SCREEN
    };
}

export const FETCH_RECOMMENDATIONS = 'FETCH_RECOMMENDATIONS';
export type FETCH_RECOMMENDATIONS = typeof FETCH_RECOMMENDATIONS;

export interface FetchRecommendations {
    type: FETCH_RECOMMENDATIONS;
}

export function fetchRecommendations(): FetchRecommendations {
    return {
        type: FETCH_RECOMMENDATIONS
    };
}

export const UPDATE_RECOMMENDATIONS = 'UPDATE_RECOMMENDATIONS';
export type UPDATE_RECOMMENDATIONS = typeof UPDATE_RECOMMENDATIONS;

export interface UpdateRecommendations {
    type: UPDATE_RECOMMENDATIONS;
    recommendations: Array<SummaryRecommendation>;
    recommendationsReqId: string;
}

export function updateRecommendations(
    recommendations: Array<SummaryRecommendation>,
    recommendationsReqId: string
): UpdateRecommendations {
    return {
        type: UPDATE_RECOMMENDATIONS,
        recommendations,
        recommendationsReqId
    };
}

export const FIRE_SHOW_RECOMMENDATION_CARD_EVENT = 'FIRE_SHOW_RECOMMENDATION_CARD_EVENT';
export type FIRE_SHOW_RECOMMENDATION_CARD_EVENT = typeof FIRE_SHOW_RECOMMENDATION_CARD_EVENT;

export interface FireShowRecommendationCardEvent {
    type: FIRE_SHOW_RECOMMENDATION_CARD_EVENT;
    recommendationType: RecommendationType;
}

export function fireShowRecommendationCardEvent(
    recommendationType: RecommendationType
): FireShowRecommendationCardEvent {
    return {
        type: FIRE_SHOW_RECOMMENDATION_CARD_EVENT,
        recommendationType
    };
}

export const SUBMIT_RECOMMENDATION_CARD = 'SUBMIT_RECOMMENDATION_CARD';
export type SUBMIT_RECOMMENDATION_CARD = typeof SUBMIT_RECOMMENDATION_CARD;

export interface SubmitRecommendationCard {
    type: SUBMIT_RECOMMENDATION_CARD;
    recommendationType: RecommendationType;
    keys: Array<RecommendationKey>;
}

export function submitRecommendationCard(
    recommendationType: RecommendationType,
    keys: Array<RecommendationKey>
): SubmitRecommendationCard {
    return {
        type: SUBMIT_RECOMMENDATION_CARD,
        recommendationType,
        keys
    };
}

export const UPDATE_RECOMMENDATION_CARD_STATUS = 'UPDATE_RECOMMENDATION_CARD_STATUS';
export type UPDATE_RECOMMENDATION_CARD_STATUS = typeof UPDATE_RECOMMENDATION_CARD_STATUS;

export interface UpdateRecommendationCardStatus {
    type: UPDATE_RECOMMENDATION_CARD_STATUS;
    recommendationType: RecommendationType;
    status: GdRecommendationStatus;
}

export function updateRecommendationCardStatus(
    recommendationType: RecommendationType,
    status: GdRecommendationStatus
): UpdateRecommendationCardStatus {
    return {
        type: UPDATE_RECOMMENDATION_CARD_STATUS,
        recommendationType,
        status
    };
}

export const FIRE_RECOMMENDATION_CARD_SEND_LICENSE_BUTTON_CLICK_METRIKA_EVENT =
    'FIRE_RECOMMENDATION_CARD_SEND_LICENSE_BUTTON_CLICK_METRIKA_EVENT';
export type FIRE_RECOMMENDATION_CARD_SEND_LICENSE_BUTTON_CLICK_METRIKA_EVENT = typeof FIRE_RECOMMENDATION_CARD_SEND_LICENSE_BUTTON_CLICK_METRIKA_EVENT;

export interface FireRecommendationCardSendLicenseButtonClickMetrikaEvent {
    type: FIRE_RECOMMENDATION_CARD_SEND_LICENSE_BUTTON_CLICK_METRIKA_EVENT;
}

export function fireRecommendationCardSendLicenseButtonClickMetrikaEvent(): FireRecommendationCardSendLicenseButtonClickMetrikaEvent {
    return {
        type: FIRE_RECOMMENDATION_CARD_SEND_LICENSE_BUTTON_CLICK_METRIKA_EVENT
    };
}

export const GET_RECOMMENDATION_APPLY_CARD_STATUS = 'GET_RECOMMENDATION_APPLY_CARD_STATUS';
export type GET_RECOMMENDATION_APPLY_CARD_STATUS = typeof GET_RECOMMENDATION_APPLY_CARD_STATUS;

export interface GetRecommendationCardStatus {
    type: GET_RECOMMENDATION_APPLY_CARD_STATUS;
    recommendationType: RecommendationType;
    requestedKeys: Array<RecommendationKey>;
    enabledForApplyKeys: Array<RecommendationKey>;
}

export function getRecommendationApplyCardStatus(
    recommendationType: RecommendationType,
    requestedKeys: Array<RecommendationKey>,
    enabledForApplyKeys: Array<RecommendationKey>
): GetRecommendationCardStatus {
    return {
        type: GET_RECOMMENDATION_APPLY_CARD_STATUS,
        recommendationType,
        requestedKeys,
        enabledForApplyKeys
    };
}

export const NO_RECOMMENDATIONS_ERROR_SHOWN = 'NO_RECOMMENDATIONS_ERROR_SHOWN';
export type NO_RECOMMENDATIONS_ERROR_SHOWN = typeof NO_RECOMMENDATIONS_ERROR_SHOWN;

export interface NoRecommendationsErrorShown {
    type: NO_RECOMMENDATIONS_ERROR_SHOWN;
}

export function noRecommendationsErrorShown(): NoRecommendationsErrorShown {
    return {
        type: NO_RECOMMENDATIONS_ERROR_SHOWN
    };
}

export type RecommendationsAction =
    | OpenRecommendationsScreen
    | UpdateRecommendations
    | FetchRecommendations
    | SubmitRecommendationCard
    | UpdateRecommendationCardStatus
    | FireRecommendationCardSendLicenseButtonClickMetrikaEvent
    | GetRecommendationCardStatus
    | NoRecommendationsErrorShown
    | FireShowRecommendationCardEvent;
